import { Navigate } from 'react-router-dom';

import * as pathes from './pathes';

import HomePage from 'pages/home';

type RouteT = {
  path: string;
  component: React.ReactElement;
};

const routes: RouteT[] = [
  { path: pathes.home, component: <HomePage /> },
  // add routes here
  {
    path: pathes.unregistered,
    component: <Navigate to={pathes.home} replace />,
  },
];

export default routes;
